<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>User Profile</h1>
            </div>
        </div>
    </div>
    <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
    <!-- Default box -->
    <div class="container-fluid">
        <div class="row">
            <!-- left column -->
            <div class="col-md-12">
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Profile</h3>
            </div>
                <div class="card-body">
                    <div *ngIf="isReadMode">
                    <input type="button" *ngIf="userRecord[0].role != 'USER'" style="float: right;" (click)="changeView()" value="Edit Profile"
                        class="btn btn-primary">
                        <!-- <a [routerLink]="['/','view-profile']" style="float: right;" (click)="changeView()"
                        class="btn btn-primary pull-right">Edit Profile</a> -->
                    <br>
                    <br>
                    <div class="row">
                        <div class="col-md-1">
                            
                        </div>
                        <div class="col-md-2" style="font-weight:bold">
                            <label for="">User Name:</label>
                        </div>
                        <div class="col-md-2">
                            <label>{{userRecord[0].userName}}</label>
                        </div>
                        
                        <div class="col-md-2">
                            
                        </div>
                        <div class="col-md-2" style="font-weight:bold">
                            <label for="">State Name :</label>
                            
                        </div>
                        <div class="col-md-2">
                            <label>{{userRecord[0].stateName}}</label>
                        </div>
                        <div class="col-md-1">
                            
                        </div>
                        
                    </div>
                    <div class="row">
                        <div class="col-md-1">
                            
                        </div>
                        <div class="col-md-2" style="font-weight:bold">
                            <label for="">Role :</label>
                        </div>
                        <div class="col-md-2">
                            <label>{{userRecord[0].role == 'null' ? 'N/A' : userRecord[0].role}}</label>
                        </div>
                        
                        <div class="col-md-2">
                            
                        </div>
                         <div class="col-md-2" style="font-weight:bold">
                            <label for="">Designation:</label></div>
                        <div class="col-md-2">
                            <label>{{userRecord[0].designation}}</label>
                        </div>
                        <div class="col-md-1">
                            
                        </div>
                        
                    </div>
                    <div class="row">
                        <div class="col-md-1">
                            
                        </div>
                        <div class="col-md-2" style="font-weight:bold">
                            <label for="">Email Id:</label>
                        </div>
                        <div class="col-md-2">
                            <label>{{userRecord[0].emailId}}</label>
                        </div>
                        
                        <div class="col-md-2">
                            
                        </div>
                        <div class="col-md-2" style="font-weight:bold">
                            <label for="">Mobile No :</label>
                            
                        </div>
                        <div class="col-md-2">
                            <label>{{userRecord[0].mobileNo}}</label>
                        </div>
                        <div class="col-md-1">
                            
                        </div>
                        
                    </div>
                    <!-- <div class="row">
                        <div class="col-md-5">
                            
                        </div>
                        <div class="col-md-5">
                            <span style="color:red;" *ngIf="message">{{message}}</span>
                            <input class="form-control" type="file" id="myInput" (change)="onFileSelect($event)" style="float: left;">
                        </div>
                        <div class="col-md-5">
                            <img [src]="imgURL" height="100" *ngIf="imgURL" style="float: right;">
                            </div>
                        
                    </div> -->
                
                
                
                
                
                    </div>
                    <div *ngIf="!isReadMode">
                            <a [routerLink]="['/','view-profile']" style="float: right;" (click)="changeView()"
                                class="btn btn-primary pull-right">View Profile</a>
                            <br>
                            <br>
                            <div *ngIf="success" class="alert alert-success alert-dismissible fade show" role="alert">
                                <strong>Success!</strong> Your data has been saved successfully.
                                <button (click)="closeAlert()" type="button" class="close" data-dismiss="alert"
                                    aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <form [formGroup]="userForm" (ngSubmit)="onupdateProfileSubmit()">
                                <div class="form-group">
                                    
                                        <label  style="font-weight:bold">
                                            Name :
                                            <input type="text" formControlName="userName" class="form-control">
                                            <div *ngIf="submitted && userForm.controls.userName.errors" class="error">
                                                <div *ngIf="userForm.controls.userName.errors.required" style="color:red">
                                                    Name is required</div>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="form-group">
                                    <label  style="font-weight:bold">
                                        State:
                                   
                                        <select [(ngModel)]="selectedState" formControlName="stateCode" class="form-control">
                                            <option [ngValue]="null" selected disabled>Select State</option>
                                            <option *ngFor="let state of StateRecord" [ngValue]="state.stateCode">
                                                {{state.stateName}}</option>
                                        </select>
                                        <div *ngIf="submitted && userForm.controls.statecode.errors" class="error">
                                            <div *ngIf="userForm.controls.statecode.errors.required" style="color:red">
                                                State is required</div>
                                        </div>
                                    </label>
                                </div>
                                
                         
                                <div class="form-group">
                                    <label  style="font-weight:bold">
                                        Designation :
                                        <input type="text" formControlName="designation" class="form-control">
                                        <div *ngIf="submitted && userForm.controls.designation.errors" class="error">
                                            <div *ngIf="userForm.controls.designation.errors.required" style="color:red">
                                                Designation is required</div>
                                        </div>
                                    </label>
                                </div>
                                
                                <div class="form-group">
                                    <label  style="font-weight:bold">
                                        Email Id. :
                                        <input type="email" formControlName="emailId" class="form-control">
                                        <div *ngIf="submitted && userForm.controls.emailId.errors" class="error">
                                            <div *ngIf="userForm.controls.emailId.errors.required" style="color:red">Email
                                                Id is required</div>
                                        </div>
                                    </label>
                                </div>
                                <div class="form-group">
                                    <label  style="font-weight:bold">
                                        Mobile No. :
                                        <input type="text" formControlName="mobileNo" class="form-control">
                                        <div *ngIf="submitted && userForm.controls.mobileNo.errors && userForm.controls.mobileNo.invalid"
                                            class="error">
                                            <div *ngIf="userForm.controls.mobileNo.errors.required" style="color:red">
                                                Mobile No. is required</div>
                                            <div *ngIf="userForm.controls.mobileNo.errors.pattern">Please, Enter 10 digit
                                                Mobile Number.</div>
                                        </div>
                                    </label>
                                </div>
        
        
                                <br />
        
                                <div class="form-group">
                                    <input type="submit" *ngIf="userRecord[0].role != 'USER'" value="Update" (click)="goToProfile()" class="btn btn-primary"
                                        [disabled]="!userForm.valid">
                                </div>
                            </form>
        
                      
                    </div>
                 <!-- /.card-body -->
            <!-- <div class="card-footer">Footer</div> -->
            <!-- /.card-footer-->
            </div>
        </div>
        </div>
        </div>
    </div>
    </section>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>

